import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface Module {
  title: string;
  description: string;
  content?: string;
  bulletPoints?: string[];
}

export interface CourseCurriculumProps {
  duration?: string;
  language?: string;
  transcripts?: string;
  modules?: Module[];
}

export default function CourseCurriculum({
  duration,
  language,
  transcripts,
  modules,
}: CourseCurriculumProps = {}) {
  return (
    <div>
      <h2 className="mb-8 text-3xl font-bold text-[#1a1a1a]">
        Course curriculum
      </h2>
      {duration ||
        language ||
        (transcripts && (
          <div className="bg-[#ebe8e3] px-8 py-4 rounded-t-[10px]">
            <h3 className="text-xl font-semibold text-[#1a1a1a] !py-0 !mt-0 mb-4">
              {duration}
            </h3>
            <div className="flex flex-wrap items-center gap-x-4 text-base">
              <div className="flex items-center gap-2">
                <span className="font-semibold text-[#1a1a1a]">Language</span>
                <span className="text-[#1a1a1a]">{language}</span>
              </div>
              <span className="text-[#666]">|</span>
              <div className="flex items-center gap-2">
                <span className="font-semibold text-[#1a1a1a]">
                  Transcripts
                </span>
                <span className="text-[#1a1a1a]">{transcripts}</span>
              </div>
            </div>
          </div>
        ))}

      <Accordion
        type="single"
        collapsible
        className="overflow-hidden border border-[#e0ddd8]"
      >
        {modules?.map((module, index) => (
          <AccordionItem
            key={`module-${index}`}
            value={`module-${index}`}
            className={`bg-white !mt-0 !mb-0 [&_h3]:mt-1 [&_h3]:mb-1 px-8 ${index !== 0 ? "border-t border-[#e0ddd8]" : ""}`}
          >
            <AccordionTrigger className="text-left hover:no-underline">
              <p className="text-base text-[#1a1a1a]">
                <span className="font-semibold">{module.title}:&nbsp;</span>
                <span className="font-normal">{module.description}</span>
              </p>
            </AccordionTrigger>
            <AccordionContent className="text-[#666]">
              {module.content ||
                "Module content will be displayed here when expanded."}
              {module.bulletPoints && module.bulletPoints.length > 0 && (
                <ul className="pl-0 mt-2 list-disc list-outside">
                  {module.bulletPoints.map((point, pointIndex) => (
                    <li key={pointIndex}>{point}</li>
                  ))}
                </ul>
              )}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
